
import "./checkout-submit-notification-v1"
import "./checkout-apple-pay-button-v1"
import { isElementVisibleOnViewport } from '@yggdrasil/Utils/general'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutSubmitButtonV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}



  onSubmit(element) {}
  
  mount() {
    this.storeButtonInitialHTML()

    this.getSubmitButton().addEventListener('click', (evt) => {
      evt.preventDefault()
      this.onSubmit(this.element)
    })

    const checkoutElement = this.element.closest('.elCheckout')
    Checkout.store.state.listen((state) => {
      if (state === Checkout.StoreStates.INITIALIZED) {
        document.addEventListener('keydown', (evt) => {
          if (evt.keyCode === 13 && $(this.element).is(':visible')) {
            if (isElementVisibleOnViewport(checkoutElement, 20)) {
              this.element.focus()
              this.onSubmit(this.element)
            }
          }
        })
      }
    })
  }

  getSubmitButton() {
    return this.element.querySelector('[href="#submit-checkout-form"]')
  }

  storeButtonInitialHTML() {
    const buttonMainText = this.element.querySelector('.elButtonMain .elButtonMainText')
    const buttonSubText = this.element.querySelector('.elButtonSub')

    this.buttonMainTextInitialHTML = buttonMainText.innerHTML
    this.buttonSubTextInitialHTML = buttonSubText.innerHTML
  }

  setButtonInitialHTML() {
    this.element.removeAttribute('data-loading')
    const buttonMain = this.element.querySelector('.elButtonMain')
    const buttonSub = this.element.querySelector('.elButtonSub')
    buttonMain.querySelector('.elButtonSpinner').style.removeProperty('display');

    const buttonMainText = buttonMain.querySelector('.elButtonMainText')
    buttonMainText.innerHTML = this.buttonMainTextInitialHTML
    buttonSub.innerHTML = this.buttonSubTextInitialHTML
  }

  setLoading() {
    this.element.setAttribute('data-loading', 'true')
  }

  setSubmittingText() {
    this.element.removeAttribute('data-loading')
    const buttonMain = this.element.querySelector('.elButtonMain')
    const buttonSub = this.element.querySelector('.elButtonSub')

    buttonMain.querySelector('.elButtonSpinner').style.display = 'inline-block'

    const buttonMainText = buttonMain.querySelector('.elButtonMainText')
    buttonMainText.innerHTML = this.submittingText
    buttonSub.innerHTML = ''
  }

  update({text, subText}: {text: string, subText: string}) {
    this.element.removeAttribute('data-loading')

    const buttonMain = this.element.querySelector('.elButtonMain')
    const buttonSub = this.element.querySelector('.elButtonSub')

    const buttonMainText = buttonMain.querySelector('.elButtonMainText')
    buttonMainText.textContent = text
    buttonSub.textContent = subText
  }



}

registerComponent('CheckoutSubmitButton/V1', CheckoutSubmitButtonV1)
window["CheckoutSubmitButtonV1"] = CheckoutSubmitButtonV1

